{
  "userSelect": {
    "placeholder": "Felhasználó kiválasztása",
    "loading": "Betöltés...",
    "noUsers": "Nem található felhasználó",
    "error": "Hiba a felhasználók betöltésekor",
    "search": "Felhasználók keresése...",
    "noResults": "Nem található felhasználó.",
    "allDepartments": "Összes osztály",
    "usersSelected": "{{count}} felhasználó kiválasztva",
    "usersSelected_one": "{{count}} felhasználó kiválasztva",
    "usersSelected_other": "{{count}} felhasználó kiválasztva",
    "noManager": "Nincs menedzser",
    "default": "Alapértelmezett"
  },
  "departmentSelect": {
    "placeholder": "Osztály kiválasztása",
    "loading": "Betöltés...",
    "noDepartments": "Nem található osztály",
    "error": "Hiba az osztályok betöltésekor",
    "search": "Osztályok keresése...",
    "noResults": "Nem található osztály.",
    "allDepartments": "Összes osztály",
    "noParentDepartment": "Nincs szülő osztály"
  },
  "orgFunctionSelect": {
    "placeholder": "Funkció kiválasztása",
    "loading": "Betöltés...",
    "noOrgFunctions": "Nem található Funkció",
    "error": "Hiba a Funkciók betöltésekor",
    "search": "Funkciók keresése...",
    "noResults": "Nem található Funkció.",
    "noOrgFunction": "Nincs Funkció"
  },
  "systemSelect": {
    "placeholder": "Rendszer kiválasztása",
    "loading": "Betöltés...",
    "noSystems": "Nem található rendszer",
    "error": "Hiba a rendszerek betöltésekor",
    "search": "Rendszerek keresése...",
    "noResults": "Nem található rendszer.",
    "noSystem": "Nincs rendszer",
    "systemsSelected": "{{count}} kiválasztva"
  },
  "userTransferListbox": {
    "error": "Hiba a felhasználók betöltésekor",
    "noUsers": "Nincsenek elérhető felhasználók",
    "availableUsers": "Elérhető személyek",
    "selectedUsers": "Kiválasztott személyek",
    "searchUsers": "Személyek keresése…"
  },
  "surveyDialog": {
    "title": "Folyamatlépés visszajelzés",
    "description": "Visszajelzése segít a folyamatok javításában. Kérjük, ossza meg velünk, hogyan éli meg ezt a folyamatlépést.",
    "ratingQuestion": "Mennyire működik jól ez a lépés az Ön számára?",
    "commentPlaceholder": "Ossza meg gondolatait erről a folyamatlépésről...",
    "frequencyQuestion": "Milyen gyakran végzi el ezt a folyamatlépést?",
    "frequencyPlaceholder": "Gyakoriság kiválasztása",
    "timesPerDayQuestion": "Naponta hányszor?",
    "timesPerWeekQuestion": "Hetente hányszor?",
    "timesPerPeriodPlaceholder": "Adjon meg egy számot (pl. 5)",
    "durationQuestion": "Mennyi ideig tart ez a lépés átlagosan? (percben)",
    "durationPlaceholder": "Adja meg az időtartamot percben (pl. 30)",
    "submit": "Visszajelzés küldése",
    "cancel": "Mégse",
    "recordedBy": "Rögzítette",
    "processStep": "Folyamatlépés",
    "ratingSection": "Visszajelzése",
    "metricsSection": "Ráfordítás és gyakoriság",
    "addCommentOptional": "Megjegyzés hozzáadása",
    "variantQuestion": "Pontosan így végzi ezt a lépést?",
    "variantSame": "Igen, pontosan így",
    "variantSameDescription": "Pontosan a leírtak szerint végzem a lépést.",
    "variantDifferent": "Igen, de másképp",
    "variantDifferentDescription": "Elvégzem a lépést, de a saját módszerem szerint.",
    "variantNotPerformed": "Nem végzem ezt a lépést",
    "variantNotPerformedDescription": "Ez a lépés nem tartozik a munkámhoz.",
    "variantDescriptionQuestion": "Mit csinál másképp?",
    "variantDescriptionPlaceholder": "Írja le, miben tér el az Ön munkamódszere...",
    "closedTitle": "Ez a felmérés lezárult",
    "closedCompleted": "Válaszait már mentettük.",
    "closedDismissed": "Ön azt jelezte, hogy nem végzi ezt a lépést.",
    "closedNotApplicable": "Ehhez a felméréshez Önnek nincs mit válaszolnia."
  }
}
